'use client';

import { useState } from 'react';
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/react';
import { ChevronDownIcon, PlayIcon } from '@heroicons/react/20/solid';
import Link from 'next/link';
import { menuItem } from '../SecondaryMenu';

type DropdownListProps = {
  title: string;
  items: menuItem[];
  selectedItem?: menuItem;
};

export default function DropdownList({
  title,
  items,
  selectedItem,
}: DropdownListProps) {
  const [selected, setSelected] = useState(selectedItem);

  const onSelect = (item: menuItem) => {
    setSelected(item);
  };

  return (
    <Listbox value={selected} onChange={onSelect}>
      <Label className="sr-only">Select Common {title}</Label>
      <div className="relative">
        <ListboxButton className="inline-flex shadow-sm gap-x-1">
          <div className="inline-flex gap-x-1.5">
            <p className="text-sm">{title}</p>
          </div>
          <div className="inline-flex">
            <span className="sr-only">Select Common {title}</span>
            <ChevronDownIcon
              aria-hidden="true"
              className="h-5 w-5 text-gray-500"
            />
            {/* <ChevronUpIcon aria-hidden="true" className="h-5 w-5 hidden" /> */}
          </div>
        </ListboxButton>

        <ListboxOptions
          transition
          className="absolute left-[-24px] z-20 mt-3 w-44 origin-top-right divide-y divide-gray-200 overflow-hidden bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
        >
          {items.map((option) => (
            <ListboxOption
              key={option.title}
              value={option}
              className="group cursor-default select-none pr-2 py-2 text-sm data-[selected]:bg-gray-100 data-[focus]:bg-gray-200"
            >
              <div className="flex flex-col">
                <Link href={option.href} className="relative">
                  <span className="absolute top-0 -ml-[6px] left-0 [.group:not([data-selected])_&]:hidden">
                    <PlayIcon
                      aria-hidden="true"
                      className="h-5 w-5 text-primary"
                    />
                  </span>
                  <span className="ml-6 font-normal group-data-[selected]:font-semibold">
                    {option.title}
                  </span>
                </Link>
              </div>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
}
